<template>
  <div
    class="rank_picker"
    :class="[
      currentGameSlug,
      isSelected && 'selected',
      isDisabled && 'disabled',
    ]"
    @click="() => selectDivision(division)"
  >
    <h4 class="division_title bold-xl t-white font-family-2">
      {{ divisionTitle }}
    </h4>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  props: {
    divisionTitle: {
      type: String,
      default: "",
    },
    division: {
      default: null,
    },
    selectDivision: {
      default: () => {},
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const { currentGameSlug } = useGameComposable();
    return {
      currentGameSlug,
    };
  },
};
</script>
